module.exports = __webpack_public_path__ + "img/scroll.23a6ae8.png";